import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { base } from "../../constants/apis";
import CookieService from "../../context/cookies";
import { VendorContact, VendorContactsRes } from "../../types/VendorContact";

export const vendorContactsApi = createApi({
  reducerPath: "vendorContacts",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/vendor_contacts`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["vendorContacts"],
  endpoints: (builder) => ({
    getVendorContacts: builder.query<VendorContact[], void>({
      query: () => "/get.php",
      providesTags: ["vendorContacts"],
      transformResponse: (res: VendorContactsRes) =>
        res.status === "success" ? res.data.reverse() : [],
    }),
    addVendorContact: builder.mutation({
      query: (payload) => ({
        url: "/add.php",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["vendorContacts"],
    }),
    updateVendorContact: builder.mutation({
      query: (payload) => ({
        url: "/update.php",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["vendorContacts"],
    }),
  }),
});

export const {
  useAddVendorContactMutation,
  useGetVendorContactsQuery,
  useUpdateVendorContactMutation,
} = vendorContactsApi;
